<div>
  <table class="table-header">
    <thead>
      <tr class="row">
        <th class="col-3">{{''|i18n:'field-requiring-overrule'}}</th>
        <th class="col-3">{{''|i18n:'required-value'}}</th>
        <th class="col-3">{{''|i18n:'justification'}}</th>
        <th class="col-3">{{''|i18n: declined() ? 'decline-reason' : 'supporting-material'}}</th>
      </tr>
    </thead>
  </table>
  <div class=" row">
    <span class="col-3">{{'' | i18n: specialRequest?.specialRequestFields[0].name}}</span>
    <span class="col-3">{{specialRequest?.requirements}}</span>
    <span class="col-3">{{specialRequest?.justification}}</span>
    @if (declined()) {
      <span class="col-3">{{specialRequest.declineReason}}</span>
    }
    @if (!declined()) {
      <span><a class="submit-warranty-cancel"
      (click)="downloadSupportingMaterial()">{{specialRequest?.supportingMaterialFileName}}</a></span>
    }
  </div>
</div>
<hr/>

